class StickyNavigation {
  constructor(options) {
    this._options = { ...StickyNavigation.options, ...options };
    this._init();
  }

  static options = {
    pace: 350,
  };

  _state = {
    direction: 'down',
    status: 'enter',
    previousY: 0,
    previousRatio: 0,
  };

  _cacheSelectors() {
    this._trigger = document.querySelector('#header');
    //this._trigger = document.querySelector('.js-stickytrigger')
    this._wrapper = document.querySelector('.wrapper');
  }

  _addEventListeners() {
    const observer = new IntersectionObserver(this._handleIntersect, {
      threshold: 0,
    });

    observer.observe(this._trigger);

    window.addEventListener('scroll', () => {
      // detects new state and compares it with the new one
      if (document.body.getBoundingClientRect().top > this._state.previousY) {
        this._state.direction = 'up';
      } else {
        this._state.direction = 'down';
      }
      this._wrapper.setAttribute('data-direction', this._state.direction);
      this._state.previousY = document.body.getBoundingClientRect().top;
    });
  }

  _init() {
    this._cacheSelectors();
    if (this._trigger) {
      this._addEventListeners();
    }
  }

  _handleIntersect = (entries) => {
    entries.forEach((entry) => {
      const { isIntersecting } = entry;
      if (isIntersecting) {
        this._state.status = 'enter';
      } else {
        this._state.status = 'leave';
      }
      this._wrapper.setAttribute('data-status', this._state.status);
    });
  };
}

export default StickyNavigation;
